import React from "react";
import PropTypes from "prop-types";
import { Text } from "@badi/badi-components";
import { StyledSubHeading } from "./styled-components";

const Subheading = ({ content, color, dataQa }) => (
  <Text as={StyledSubHeading} body="10-Medium" color={color} data-qa={dataQa}>
    {content}
  </Text>
);

Subheading.propTypes = {
  color: PropTypes.string.isRequired,
  content: PropTypes.string.isRequired,
  dataQa: PropTypes.string.isRequired,
};

export default Subheading;
